type TAllowedTypes = Element | EventTarget;

export const isHtmlElement = (element: TAllowedTypes): element is HTMLElement => element instanceof HTMLElement;
